import Icon from './Icon';
import IconWithBadge from './IconWithBadge';
import IconWithCount from './IconWithCount';

export { IconWithBadge, IconWithCount };
export default Icon;
